import React from 'react';
import { TextField, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const OrderComment = ({ setComment, showOptionalCaption = false }) => {
  const { t } = useTranslation(['description']);

  const label = showOptionalCaption
    ? t('orders.deliver.comments_label')
    : t('orders.deliver.comments_label_optional');

  return (
    <Box sx={{ my: 0 }}>
      <TextField
        label={label}
        placeholder={t('orders.deliver.comments_placeholder')}
        onChange={(e) => setComment(e.target.value)}
        fullWidth
        multiline
        rows={3}
        variant="outlined"
        InputLabelProps={{
          shrink: true,
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            bgcolor: 'background.paper',
            '& fieldset': {
              borderColor: '#E0E0E0',
            },
            '&:hover fieldset': {
              borderColor: 'rgba(0, 0, 0, 0.35)',
            },
          },
          '& .MuiInputLabel-root': {
            color: 'rgba(0, 0, 0, 0.6)',
          },
        }}
      />
      {showOptionalCaption && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: 'block', mt: 0.75, ml: 0.25 }}
        >
          {t('orders.deliver.optional_caption')}
        </Typography>
      )}
    </Box>
  );
};

export default OrderComment;
